module.exports = __webpack_public_path__ + "assets/img/element-logo.99edcb36.svg";